import { Box, Button, Container, Flex, Grid, GridItem, Heading, Text } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { urlNavigate } from '../../../helper/utils/navigation';
import getStaticAsset from '../../../helper/utils/utilsStaticAsset';

export default function ProductList({ product }) {
    const navigate = useNavigate();

    return (
        <Box w='full' h='auto' my={16}>
            <Box w='full' h='auto'>
                <Container maxW='7xl' id='products' p={0}>
                    <Box>
                        <Heading fontSize={{ base: '4xl', md: '4xl' }} fontWeight={600}>
                            {product['title'] || ''}
                        </Heading>
                        <Text w={{ base: 'full', md: '65%' }} mt={2} fontSize={{ base: '15px', md: '17px' }} lineHeight={1.5} color='gray.600'>
                            {product['desc'] || ''}
                        </Text>
                    </Box>
                    <Box w='full' mt={14}>
                        <Grid
                            w='full'
                            position='relative'
                            overflow='hidden'
                            gridTemplateColumns={{
                                base: 'repeat(1, 1fr)',
                                md: 'repeat(3, 1fr)',
                                lg: 'repeat(4, 1fr)',
                            }}
                            gap={4}>
                            {(product['items'] || [])?.map((product, index) => {
                                const { cta, ctaTitle, title, desc, image } = product;
                                return (
                                    <GridItem key={index} w='full' h='265px' bg='white' rounded='xl' bgImage={getStaticAsset(image)} bgSize='cover' bgRepeat='no-repeat' bgPosition='center' cursor='pointer' overflow='hidden' transition='all 0.25s ease-in-out' role='group'>
                                        <Box w='full' h='full' bgGradient='linear(to-t, rgba(0, 0, 0, 0.75), rgba(0, 0, 0, 0.1))' transition='all 0.25s ease-in-out' p={5}>
                                            <Flex w='full' h='full' alignItems='start' justifyContent='end' flexDirection='column' transition='all 0.25s ease-in-out'>
                                                <Text
                                                    transition='all 0.25s ease-in-out'
                                                    color='white'
                                                    noOfLines={1}
                                                    casing='capitalize'
                                                    fontSize={{
                                                        base: 'xl',
                                                        md: 'lg',
                                                    }}
                                                    fontWeight={600}>
                                                    {title}
                                                </Text>
                                                <Text transition='all 0.25s ease-in-out' noOfLines={1} lineHeight={1.35} mt={1} mb={6} fontSize='15px' fontWeight={500} color='gray.200'>
                                                    {desc}
                                                </Text>
                                                <Button
                                                    transition='all 0.35s ease-in-out'
                                                    fontSize='13px'
                                                    colorScheme='primary'
                                                    onClick={() => {
                                                        localStorage.setItem('product', JSON.stringify(product));

                                                        if (typeof cta === 'function') {
                                                            cta();
                                                            return;
                                                        }

                                                        navigate(urlNavigate(cta));
                                                    }}>
                                                    {ctaTitle}
                                                </Button>
                                            </Flex>
                                        </Box>
                                    </GridItem>
                                );
                            })}
                        </Grid>
                    </Box>
                </Container>
            </Box>
        </Box>
    );
}
